// extracted by mini-css-extract-plugin
export default {"host":"style_host__DMnQJ","centerCell":"style_centerCell__IA2bo"};